import eventEmitter from '../infraestructure/eventEmitter'
import authRepository from '../repository/auth.repository'
import {
  getUserRoles,
  saveAgentUserName,
  saveUserRoles,
} from './storage.service'

export enum Events {
  AUTHENTICATED_USER = 'UserService::AUTHENTICATED_USER',
}

export const getAuthenticatedUser = () => authRepository.getAuthenticatedUser()

export const logIn = async (userId: string, localizer: string) =>
  authRepository.login(userId, localizer)

export const authUser = async () => {
  const currentUser = await getAuthenticatedUser()

  eventEmitter.emit(Events.AUTHENTICATED_USER, currentUser)
  saveUserRoles(currentUser.data.roles)
  saveAgentUserName(currentUser.data.userName)
}

export const isAuthenticated = () => {
  const roles = getUserRoles()
  return Boolean(roles) && roles.indexOf('ROLE_ANONYMOUS') === -1
}

export const hasPermission = (allowedRoles: string[]) => {
  if (!isAuthenticated()) {
    throw new Error('User is not authenticated')
  }

  return getUserRoles().some(role =>
    allowedRoles.some(validRole => validRole === role),
  )
}

export const hasNoRoles = () => {
  return (
    !getUserRoles() ||
    getUserRoles().length <= 0 ||
    getUserRoles().includes(process.env.REACT_APP_ROLE_ANONYMOUS)
  )
}
